module.exports = __webpack_public_path__ + "img/Canal_RRHH+.75f031d6.svg";